import { trackEvent } from '../lib/analytics';
import { useTrainingSession } from './session';
import { COMPLETION_RECORDS } from './fixtures';

export function CompletionRecords() {
  const { persona } = useTrainingSession();

  if (persona !== 'manager') {
    return (
      <div className="tr-root">
        <div className="tr-wrap tr-appsec">
          <div className="tr-gate">
            <h2>Manager access needed</h2>
            <p>Completion records are visible to the manager who bought Pro for the team. Switch to the manager persona above to see them.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tr-root">
      <div className="tr-wrap tr-appsec">
        <div className="tr-mgr-head">
          <div>
            <h1 className="tr-h1">Completion records</h1>
            <p className="tr-sub">
              Dated proof of what each person finished. Export it for your
              own files, your insurer, or whoever asks.
            </p>
          </div>
        </div>

        <div className="tr-tblbar">
          <h3>{COMPLETION_RECORDS.length} records</h3>
          <button
            className="tr-btn tr-btn-navy tr-btn-sm"
            onClick={() => trackEvent('records_exported', { count: COMPLETION_RECORDS.length })}
          >
            <i className="ti ti-download"></i> Download records
          </button>
        </div>

        <table className="tr-table">
          <thead>
            <tr>
              <th>Person</th>
              <th>Module</th>
              <th>Completed</th>
              <th>Knowledge check</th>
            </tr>
          </thead>
          <tbody>
            {COMPLETION_RECORDS.map((r, i) => (
              <tr key={`${r.personId}-${r.moduleNumber}-${i}`}>
                <td>
                  <div className="tr-who">
                    <span className="tr-av">{r.initials}</span>
                    <span className="tr-nm">{r.personName}</span>
                  </div>
                </td>
                <td>{String(r.moduleNumber).padStart(2, '0')} · {r.moduleTitle}</td>
                <td>{r.completedOn}</td>
                <td>{r.knowledgeCheckPassed ? `Passed · ${r.knowledgeCheckScore}` : 'Not passed'}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="tr-truth">
          <b>What a record means.</b> A module appears here only when every
          lesson has been worked through and the knowledge check passed.
          Opening a module doesn't count, and nothing is recorded that we
          can't stand behind.
        </div>
      </div>
    </div>
  );
}
